import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Image } from 'foundations-components/transitional/components/Image';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LearnMoreModal = ({
  children,
  closeButton,
  footer,
  heading,
  illustrationAlt,
  illustrationName,
  illustrationSrc,
  onClose
}) => {
  return /*#__PURE__*/_jsxs(Modal, {
    width: 750,
    children: [/*#__PURE__*/_jsx(DialogBody, {
      paddingBlockEnd: "600",
      paddingBlockStart: "1000",
      children: /*#__PURE__*/_jsxs(Flex, {
        children: [/*#__PURE__*/_jsxs(Flex, {
          flexBasis: '100%',
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h3",
            marginBlockEnd: "500",
            textAlign: "start",
            children: heading
          }), /*#__PURE__*/_jsx(Text, {
            textAlign: "start",
            children: children
          })]
        }), illustrationName && /*#__PURE__*/_jsx(Illustration, {
          alt: illustrationAlt,
          marginInlineStart: "500",
          name: illustrationName,
          width: 180
        }), illustrationSrc && /*#__PURE__*/_jsx(Image, {
          alt: illustrationAlt,
          marginInlineStart: "500",
          src: illustrationSrc
        })]
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      align: "left",
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        use: "primary",
        children: closeButton !== null && closeButton !== void 0 ? closeButton : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.modal.back"
        })
      }), footer]
    })]
  });
};
export default LearnMoreModal;